/**
 * Parse value and extract number and unit (e.g., "10 GB" -> {value: 10, unit: "GB"})
 * @param valueStr String containing value and optional unit
 * @returns Object with parsed value and unit
 *
 * @author Claude Code
 */
export const parseValueWithUnit = (
	valueStr: string
): {value: number; unit: string} => {
	const trimmed = valueStr.trim();

	// Try to match number followed by optional unit
	const match = trimmed.match(/^([\d.]+)\s*([a-zA-Z]*)$/);

	if (match) {
		return {
			value: parseFloat(match[1]),
			unit: match[2] || 'count',
		};
	}

	// If no match, return as-is
	return {
		value: parseFloat(trimmed) || 0,
		unit: 'count',
	};
};
